import React from "react";

const Contacto = () => {

  return (
    <>
      <h1>Hola sapo</h1>
    </>
  );
};

export default Contacto;